function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

  document.addEventListener("DOMContentLoaded", function () {
    // Get the button element
    var addButton = document.querySelector('.product-form__submit');

    // Add a scroll event listener
    window.addEventListener("scroll", function () {
      // Check if the scroll position is greater than 500px
      if (window.scrollY > 800) {
        // Add the "sticky-button" class when scrolled down
        addButton.classList.add('sticky-button');
      } else {
        // Remove the "sticky-button" class when scrolled back up
        addButton.classList.remove('sticky-button');
      }
    });
  });

window.addEventListener('scroll', function () {
  document.querySelectorAll('.sticky-button').forEach(function (el) {
    if (window.scrollY >= 800) {
      el.style.position = 'fixed';
    } else {
      el.removeAttribute('style');
    }
  });
});



const productHandle = window.location.pathname.split('/').pop();
const productMeta = JSON.parse(document.getElementById('product-meta-json')?.textContent || '{}');

document.addEventListener('DOMContentLoaded', function() {

  function isSubscriptionActive() {
    const subscriptionInput = document.querySelector('input[name="purchase_type"][value="subscription"]:checked');
    const activeSubscriptionClass = document.querySelector('.rc_widget__option--subsave.rc_widget__option--active, .rc_widget__option--subsave input:checked, .subscription-radio.rc-radio--active input:checked');

    const isSub = !!subscriptionInput || !!activeSubscriptionClass;

    console.log('isSubscriptionActive:', isSub);
    return isSub;
  }

  function getFeaturedImageTag() {
    const imageElement =
      document.querySelector('.product__media img') ||
      document.querySelector('.product__main-img') ||
      document.querySelector('.product-gallery img') ||
      document.querySelector('meta[property="og:image"]');
    const imageUrl = imageElement?.src || imageElement?.content ||
      'https://cdn.shopify.com/s/files/1/0533/2089/files/no-image.gif';
    return `<img src="${imageUrl}" alt="Pack" style="width: 20px; height: auto; vertical-align: middle;" />`;
  }

  function waitForElement(selector, callback, maxAttempts = 25, interval = 250) {
    let attempts = 0;
    const checkElement = () => {
      const element = document.querySelector(selector);
      if (element) {
        console.log(`Element found: ${selector}`);
        callback(element);
      } else if (attempts < maxAttempts) {
        attempts++;
        setTimeout(checkElement, interval);
      } else {
        console.warn(`Element ${selector} not found after ${maxAttempts} attempts.`);
      }
    };
    setTimeout(checkElement, interval);
  }

  function ensureElementVisibility(element, context = 'element') {
    if (element) {
      element.style.cssText = `
        display: block !important;
        opacity: 1 !important;
        visibility: visible !important;
        pointer-events: auto !important;
        position: relative !important;
        z-index: ${context === 'button' ? 10 : 1} !important;
      `;
      console.log(`${context} visibility ensured:`, element);
      return element;
    }
    console.warn(`${context} not found.`);
    return null;
  }

  function toggleSubscriptionBenefits(show) {
    const trustBadgesSection = document.querySelector('.rc_popup, .rc-subscription-details');
    if (!trustBadgesSection) {
      console.warn('Trust badges section not found.');
      return;
    }
    let subscriptionBenefits = document.querySelector('#subscription-benefits');
    if (show && !subscriptionBenefits) {
     
      trustBadgesSection.style.display = 'block';
      subscriptionBenefits = document.createElement('div');
      subscriptionBenefits.id = 'subscription-benefits';
      subscriptionBenefits.innerHTML = `
        <div style="font-weight: bold; margin-bottom: 3px;">Why subscribe?</div>
        <div style="display: flex; align-items: flex-start; margin-bottom: 2px;">
          <span style="margin-right: 8px;"><svg xmlns="http://www.w3.org/2000/svg" fill="none" height="20" viewBox="0 0 20 20" width="20">
            <mask height="20" id="mask0_371_85" maskUnits="userSpaceOnUse" style="mask-type:alpha" width="20" x="0" y="0">
              <rect fill="#D9D9D9" height="20" width="20"/>
            </mask>
            <g mask="url(#mask0_371_85)">
              <path d="M8.83335 13.8333L14.7084 7.95829L13.5417 6.79163L8.83335 11.5L6.45835 9.12496L5.29169 10.2916L8.83335 13.8333ZM10 18.3333C8.84724 18.3333 7.76391 18.1145 6.75002 17.677C5.73613 17.2395 4.85419 16.6458 4.10419 15.8958C3.35419 15.1458 2.76044 14.2638 2.32294 13.25C1.88544 12.2361 1.66669 11.1527 1.66669 9.99996C1.66669 8.84718 1.88544 7.76385 2.32294 6.74996C2.76044 5.73607 3.35419 4.85413 4.10419 4.10413C4.85419 3.35413 5.73613 2.76038 6.75002 2.32288C7.76391 1.88538 8.84724 1.66663 10 1.66663C11.1528 1.66663 12.2361 1.88538 13.25 2.32288C14.2639 2.76038 15.1459 3.35413 15.8959 4.10413C16.6459 4.85413 17.2396 5.73607 17.6771 6.74996C18.1146 7.76385 18.3334 8.84718 18.3334 9.99996C18.3334 11.1527 18.1146 12.2361 17.6771 13.25C17.2396 14.2638 16.6459 15.1458 15.8959 15.8958C15.1459 16.6458 14.2639 17.2395 13.25 17.677C12.2361 18.1145 11.1528 18.3333 10 18.3333ZM10 16.6666C11.8611 16.6666 13

.4375 16.0208 14.7292 14.7291C16.0209 13.4375 16.6667 11.8611 16.6667 9.99996C16.6667 8.13885 16.0209 6.56246 14.7292 5.27079C13.4375 3.97913 11.8611 3.33329 10 3.33329C8.13891 3.33329 6.56252 3.97913 5.27085 5.27079C3.97919 6.56246 3.33335 8.13885 3.33335 9.99996C3.33335 11.8611 3.97919 13.4375 5.27085 14.7291C6.56252 16.0208 8.13891 16.6666 10 16.6666Z" fill="#645D4F"/>
            </g>
          </svg></span>
          <span>Save on every order and lock in your special pricing</span>
        </div>
        <div style="display: flex; align-items: flex-start;">
          <span style="margin-right: 5px;"><svg xmlns="http://www.w3.org/2000/svg" fill="none" height="20" viewBox="0 0 20 20" width="20">
            <mask height="20" id="mask0_371_85" maskUnits="userSpaceOnUse" style="mask-type:alpha" width="20" x="0" y="0">
              <rect fill="#D9D9D9" height="20" width="20"/>
            </mask>
            <g mask="url(#mask0_371_85)">
              <path d="M8.83335 13.8333L14.7084 7.95829L13.5417 6.79163L8.83335 11.5L6.45835 9.12496L5.29169 10.2916L8.83335 13.8333ZM10 18.3333C8.84724 18.3333 7.76391 18.1145 6.75002 17.677C5.73613 17.2395 4.85419 16.6458 4.10419 15.8958C3.35419 15.1458 2.76044 14.2638 2.32294 13.25C1.88544 12.2361 1.66669 11.1527 1.66669 9.99996C1.66669 8.84718 1.88544 7.76385 2.32294 6.74996C2.76044 5.73607 3.35419 4.85413 4.10419 4.10413C4.85419 3.35413 5.73613 2.76038 6.75002 2.32288C7.76391 1.88538 8.84724 1.66663 10 1.66663C11.1528 1.66663 12.2361 1.88538 13.25 2.32288C14.2639 2.76038 15.1459 3.35413 15.8959 4.10413C16.6459 4.85413 17.2396 5.73607 17.6771 6.74996C18.1146 7.76385 18.3334 8.84718 18.3334 9.99996C18.3334 11.1527 18.1146 12.2361 17.6771 13.25C17.2396 14.2638 16.6459 15.1458 15.8959 15.8958C15.1459 16.6458 14.2639 17.2395 13.25 17.677C12.2361 18.1145 11.1528 18.3333 10 18.3333ZM10 16.6666C11.8611 16.6666 13.4375 16.0208 14.7292 14.7291C16.0209 13.4375 16.6667 11.8611 16.6667 9.99996C16.6667 8.13885 16.0209 6.56246 14.7292 5.27079C13.4375 3.97913 11.8611 3.33329 10 3.33329C8.13891 3.33329 6.56252 3.97913 5.27085 5.27079C3.97919 6.56246 3.33335 8.13885 3.33335 9.99996C3.33335 11.8611 3.97919 13.4375 5.27085 14.7291C6.56252 16.0208 8.13891 16.6666 10 16.6666Z" fill="#645D4F"/>
            </g>
          </svg></span>
          <span>Easily Cancel, Pause, Edit with only one click</span>
        </div>
      `;
      subscriptionBenefits.style.cssText = `
        display: block !important;
        margin-bottom: 15px;
        font-size: 69%;
        padding: 7px 20px 3px;
        background-color: #f8f8f8;
        border-radius: 8px;
        border: 1px solid #000;
        margin-top: -12px;
      `;
      trustBadgesSection.parentNode.insertBefore(subscriptionBenefits, trustBadgesSection);
      console.log('Subscription benefits added:', subscriptionBenefits);
    } else if (!show && subscriptionBenefits) {
      subscriptionBenefits.remove();
     
      console.log('Subscription benefits removed.');
    }
  }

  // If productMeta already exists
// productMeta["pack_2"] = { "price_serving": "$1.95 per serving", "save_discount": "Save 15%" };
// productMeta["pack_2_sub"] = { "price_serving": "$2.10 per serving", "save_discount": "Save 15% OFF" };

  function updateLabelMetaFields(label) {
    if (!label.dataset.originalText) {
      label.dataset.originalText = label.innerText.trim();
    }
    const originalText = label.dataset.originalText;
    const packType = originalText.includes("Pack of 6") ? 'pack_6' :
                     originalText.includes("Pack of 3") ? 'pack_3' :
                     originalText.includes("Pack of 2") ? 'pack_2' :
                     originalText.includes("Pack of 1") ? 'pack_1' : null;

    let iconImg = getFeaturedImageTag();
    let saveyHtml = '';
    let variantLabelText = '';
    let variantPriceHtml = '';
    let matchingVariant = null;

    // Get variant text and price from section settings
    const variantRadios = label.closest('variant-radios');
    if (variantRadios) {
      const variantTextsScript = variantRadios.querySelector('script[id^="variant-texts-"]');
      if (variantTextsScript && variantTextsScript.textContent) {
        try {
          // Parse JSON from script tag
          const scriptContent = variantTextsScript.textContent.trim();
          if (scriptContent && scriptContent !== '{}' && scriptContent !== '{ }') {
            const variantTextMap = JSON.parse(scriptContent);
            
            // Find matching variant text - try exact match first
            if (variantTextMap && typeof variantTextMap === 'object') {
              if (variantTextMap[originalText]) {
                variantLabelText = variantTextMap[originalText];
              } else {
                // Try to find by variant title match
                const radioInput = document.querySelector(`input[type="radio"][id="${label.getAttribute('for')}"]`);
                if (radioInput) {
                  const variantDataScript = variantRadios.querySelector('script[type="application/json"]:not([id^="variant-texts-"])');
                  if (variantDataScript) {
                    try {
                      const variants = JSON.parse(variantDataScript.textContent);
                      const optionValue = radioInput.value;
                      
                      // Find variant that matches this option
                      matchingVariant = variants.find(v => {
                        return v.options && v.options.includes(optionValue);
                      });
                      
                      if (matchingVariant && matchingVariant.title && variantTextMap[matchingVariant.title]) {
                        variantLabelText = variantTextMap[matchingVariant.title];
                      }
                    } catch (e) {
                      console.warn('Error parsing variant data for text:', e);
                    }
                  }
                }
              }
            }
          }
        } catch (e) {
          console.warn('Error parsing variant texts JSON:', e, variantTextsScript.textContent);
        }
      }
      
      // Get variant price data
      if (!matchingVariant) {
        const radioInput = document.querySelector(`input[type="radio"][id="${label.getAttribute('for')}"]`);
        if (radioInput) {
          const variantDataScript = variantRadios.querySelector('script[type="application/json"]:not([id^="variant-texts-"])');
          if (variantDataScript) {
            try {
              const variants = JSON.parse(variantDataScript.textContent);
              const optionValue = radioInput.value;
              
              // Find variant that matches this option
              matchingVariant = variants.find(v => {
                return v.options && v.options.includes(optionValue);
              });
            } catch (e) {
              console.warn('Error parsing variant data for price:', e);
            }
          }
        }
      }
      
      // Format and display prices
      if (matchingVariant) {
        const price = matchingVariant.price / 100; // Convert from cents
        const compareAtPrice = matchingVariant.compare_at_price ? matchingVariant.compare_at_price / 100 : null;
        
        // Format price as currency
        const formatMoney = (amount) => {
          return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
          }).format(amount);
        };
        
        if (compareAtPrice && compareAtPrice > price) {
          variantPriceHtml = `<span class="variant-price" style="text-decoration: line-through; opacity: 0.6; margin-right: 8px;">${formatMoney(compareAtPrice)}</span><span class="variant-price-current">${formatMoney(price)}</span>`;
        } else {
          variantPriceHtml = `<span class="variant-price-current">${formatMoney(price)}</span>`;
        }
      }
    }

    if (packType && productMeta) {
      console.log(productMeta, "mettttttta");
      const isSubActive = isSubscriptionActive();
      const metaKey = isSubActive ? `${packType}_sub` : packType;
      const meta = productMeta[metaKey] || {};

      if (meta.price_serving || meta.save_discount) {
        saveyHtml = `<span>${meta.price_serving || 'N/A'}</span> <span>${meta.save_discount || 'N/A'}</span>`;
        console.log(`Updated saveyHtml for ${metaKey}:`, saveyHtml, 'meta:', meta);
      } else {
        saveyHtml = '<span>No price data</span>';
        console.warn(`Metafields for ${metaKey} not found:`, productMeta[metaKey]);
      }

      if (originalText.includes("Pack of 6")) {
        if (productHandle.includes('glucose')) {
          iconImg = `<img src="https://cdn.shopify.com/s/files/1/0608/2261/8286/files/BioStrips_Glucose_Support_6_Packs.png?v=1749220821" alt="Glucose Support 6 Packs">`;
        } else if (productHandle.includes('immune')) {
          iconImg = `<img src="https://cdn.shopify.com/s/files/1/0608/2261/8286/files/BioStrips_Immune_Support_6_Packs.png?v=1749220821" alt="Immune Support 6 Packs">`;
        } else if (productHandle.includes('hormone')) {
          iconImg = `<img src="https://cdn.shopify.com/s/files/1/0608/2261/8286/files/BioStrips_Hormone_Health_6_Packs.png?v=1749220821" alt="Hormone Health 6 Packs">`;
        } else if (productHandle.includes('clean')) {
          iconImg = `<img src="https://cdn.shopify.com/s/files/1/0608/2261/8286/files/BioStrips_Clean_Energy_6_Packs.png?v=1749220821" alt="Clean Energy 6 Packs">`;
        }
      } else if (originalText.includes("Pack of 3")) {
        if (productHandle.includes('glucose')) {
          iconImg = `<img src="https://cdn.shopify.com/s/files/1/0608/2261/8286/files/BioStrips_Glucose_Support_3_Packs.png?v=1749220820" alt="Glucose Support 3 Packs">`;
        } else if (productHandle.includes('immune')) {
          iconImg = `<img src="https://cdn.shopify.com/s/files/1/0608/2261/8286/files/BioStrips_Immune_Support_3_Packs.png?v=1749220820" alt="Immune Support 3 Packs">`;
        } else if (productHandle.includes('hormone')) {
          iconImg = `<img src="https://cdn.shopify.com/s/files/1/0608/2261/8286/files/BioStrips_Hormone_Health_3_Packs.png?v=1749220820" alt="Hormone Health 3 Packs">`;
        } else if (productHandle.includes('clean')) {
          iconImg = `<img src="https://cdn.shopify.com/s/files/1/0608/2261/8286/files/BioStrips_Clean_Energy_3_Packs.png?v=1749220821" alt="Clean Energy 3 Packs">`;
        }
      }
      else if (originalText.includes("Pack of 2")) {
        if (productHandle.includes('glucose')) {
          iconImg = `<img src="https://cdn.shopify.com/s/files/1/0608/2261/8286/files/BioStrips_Glucose_Support_3_Packs.png?v=1749220820" alt="Glucose Support 3 Packs">`;
        } else if (productHandle.includes('immune')) {
          iconImg = `<img src="https://cdn.shopify.com/s/files/1/0608/2261/8286/files/BioStrips_Immune_Support_3_Packs.png?v=1749220820" alt="Immune Support 3 Packs">`;
        } else if (productHandle.includes('hormone')) {
          iconImg = `<img src="https://cdn.shopify.com/s/files/1/0608/2261/8286/files/BioStrips_Hormone_Health_3_Packs.png?v=1749220820" alt="Hormone Health 3 Packs">`;
        } else if (productHandle.includes('clean')) {
          iconImg = `<img src="https://cdn.shopify.com/s/files/1/0608/2261/8286/files/BioStrips_Clean_Energy_3_Packs.png?v=1749220821" alt="Clean Energy 3 Packs">`;
        }
      }
    } else {
      console.warn('Pack type or productMeta not found for label:', originalText, productMeta);
      saveyHtml = '<span>No price data</span>';
    }

    label.innerHTML = '';
    const wrapper = document.createElement('span');
    wrapper.innerHTML = `
      <span class="icon-left" style="margin-right: 5px;">${iconImg}</span>
      <span class="origtxt-wrapper">
        <span class="wrapper-flex-col">
          <span class="origtxt">${originalText}</span>
          ${variantLabelText ? `<span class="variantText">${variantLabelText}</span>` : ''}
        </span>
      ${variantPriceHtml ? `<span class="variant-price-wrapper" style="display: flex; flex-direction: column; align-items: center; margin-top: 4px;">${variantPriceHtml}</span>` : ''}
      </span>
      <span class="savey">${saveyHtml}</span>
      <span class="icon-right" style="margin-left: 5px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"></polyline></svg>
      </span>
    `;
    label.appendChild(wrapper);
  }

  function initPriceSync() {
    
    const variantRadios = document.querySelectorAll('variant-radios input[type="radio"]');
    const quantityInput = document.querySelector('.quantity__input');
    const regularPriceElement = document.querySelector('.price-item.price-item--regular.recharge-inner-most-price, .price-item--regular, .price, .product__price');
    const submitButton = document.querySelector('.product-form__submit, [type="submit"]:not(.contact-form-submit,.quick-add__submit), .rc_widget__button, .rc_add_to_cart, .rc_button, .shopify-payment-button__button');
    const form = document.querySelector('.template-product form[action^="/cart"], .template-product .product-form, .installment');
    let priceDisplay = document.querySelector('.synced-price-cls');

    if (!priceDisplay) {
      priceDisplay = document.createElement('span');
      priceDisplay.className = 'synced-price-cls';
      priceDisplay.textContent = '$0.00';
      if (submitButton) {
        submitButton.appendChild(priceDisplay);
        console.log('Price display created and appended to submit button:', priceDisplay);
      } else {
        const formFallback = form || document.querySelector('.product__info-container, .product-form');
        if (formFallback) {
          formFallback.appendChild(priceDisplay);
          console.log('Price display appended to form fallback:', priceDisplay);
        } else {
          console.warn('No submit button or form found, price display not appended.');
        }
      }
    }

    const variantDataScript = document.querySelector('variant-radios script[type="application/json"]');
    const variants = variantDataScript ? JSON.parse(variantDataScript.textContent) : [];
    let currentVariant = null;
    let currentQuantity = 1;

    function syncPrice() {
  if (!priceDisplay) {
    console.warn('Price display not found.');
    return;
  }

  if (!currentVariant && regularPriceElement) {
    priceDisplay.textContent = regularPriceElement.textContent.trim() || '$0.00';
    console.log('Synced fallback price from regularPriceElement:', priceDisplay.textContent);
    return;
  }

  if (currentVariant) {
    let priceCents = currentVariant.price || currentVariant.compare_at_price || 0;
    const total = ((priceCents * currentQuantity) / 100).toFixed(2);
    priceDisplay.textContent = `$${total}`;
    console.log('Synced price from currentVariant:', priceDisplay.textContent);
  } else {
    priceDisplay.textContent = '$0.00';
    console.log('Fallback to $0.00 - no variant or regularPriceElement found');
  }
}

    function updatePriceDisplay() {
      if (!priceDisplay) {
        console.warn('Price display not found, cannot update price.');
        return;
      }
      if (!currentVariant) {
        syncPrice();
        console.warn('Current variant not found, using default price.');
        return;
      }

      let priceCents = currentVariant.price || currentVariant.compare_at_price || 0;
      const selectedPlanId = document.querySelector('input[name*="selling_plan"]')?.value;

      if (isSubscriptionActive() && selectedPlanId && currentVariant.selling_plan_allocations?.length) {
        const matchedPlan = currentVariant.selling_plan_allocations.find(
          alloc => alloc.selling_plan_id == selectedPlanId
        );
        if (matchedPlan?.price) {
          priceCents = matchedPlan.price;
          console.log('Using subscription price:', priceCents, 'for plan:', selectedPlanId);
        } else {
          console.warn('No matching selling plan found for ID:', selectedPlanId, 'falling back to variant price:', priceCents);
        }
      } else {
        console.log('Using one-time price:', priceCents);
      }

      const total = ((priceCents * currentQuantity) / 100).toFixed(2);
      priceDisplay.textContent = `$${total}`;
      console.log('Price updated:', priceDisplay.textContent, 'quantity:', currentQuantity);
    }

    function updateSellingPlanInput() {
      if (!form || !currentVariant) {
        console.warn('Form or current variant not found.');
        return;
      }

      const existingInput = form.querySelector('input[name="selling_plan"]');
      const sellingPlanId = currentVariant.selling_plan_allocations?.[0]?.selling_plan_id;

      if (isSubscriptionActive() && sellingPlanId) {
        if (existingInput) {
          existingInput.value = sellingPlanId;
        } else {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'selling_plan';
          input.value = sellingPlanId;
          form.appendChild(input);
        }
        console.log('Updated selling plan input:', sellingPlanId);
      } else if (existingInput) {
        existingInput.remove();
        console.log('Removed selling plan input.');
      }
    }

    function handleVariantChange() {
      const selectedVariantValue = document.querySelector('variant-radios input[type="radio"]:checked')?.value;
      currentVariant = selectedVariantValue ? variants.find(v => v.title === selectedVariantValue || v.id == selectedVariantValue) : null;
      console.log('Variant changed:', currentVariant?.title || currentVariant?.id);
      updatePriceDisplay();
      updateSellingPlanInput();
      const labels = document.querySelectorAll('variant-radios label');
      labels.forEach(label => updateLabelMetaFields(label));
    }

    function handleQuantityChange() {
      currentQuantity = parseInt(quantityInput?.value) || 1;
      console.log('Quantity changed:', currentQuantity);
      updatePriceDisplay();
    }

    function handleSubscriptionChange() {
      const isSubActive = isSubscriptionActive();
      console.log('Subscription state changed:', isSubActive);
      toggleSubscriptionBenefits(isSubActive);
      updatePriceDisplay();
      updateSellingPlanInput();
      const labels = document.querySelectorAll('variant-radios label');
      labels.forEach(label => updateLabelMetaFields(label));
    }

    function runPriceSyncUpdates() {
      handleVariantChange();
      handleSubscriptionChange();
      syncPrice();
      setTimeout(() => {
        if (isSubscriptionActive()) {
          handleSubscriptionChange();
          console.log('Fallback subscription price and label update triggered.');
        }
      }, 1500);
    }

    runPriceSyncUpdates();
    waitForElement('variant-radios, input[name*="selling_plan"]', () => {
      runPriceSyncUpdates();
    });

    if (variantRadios.length) {
      variantRadios.forEach(radio => {
        radio.addEventListener('change', handleVariantChange);
        radio.addEventListener('click', handleVariantChange);
      });
    }

    if (quantityInput) {
      const debounce = (fn, delay) => {
        let timeout;
        return () => {
          clearTimeout(timeout);
          timeout = setTimeout(fn, delay);
        };
      };
      const debouncedQuantityChange = debounce(handleQuantityChange, 100);
      quantityInput.addEventListener('input', debouncedQuantityChange);
      quantityInput.addEventListener('change', debouncedQuantityChange);
      document.querySelectorAll('.quantity__button').forEach(button => {
        button.addEventListener('click', debouncedQuantityChange);
      });
    }

    const subscriptionRadios = document.querySelectorAll('input[name="purchase_type"], .rc-radio__input, [name*="selling_plan"]');
   if (subscriptionRadios.length) {
  subscriptionRadios.forEach(radio => {
    radio.addEventListener('change', () => {
      console.log('Subscription radio changed:', radio);

      handleVariantChange();

      handleSubscriptionChange();

      if (!isSubscriptionActive()) {
        console.log('One-time selected — forcing price sync and display update');
        syncPrice();
        updatePriceDisplay();
      }
    });

    radio.addEventListener('click', () => {
      console.log('Subscription radio clicked:', radio);

      handleVariantChange();
      handleSubscriptionChange();

      if (!isSubscriptionActive()) {
        console.log('One-time clicked — forcing price sync and display update');
        syncPrice();
        updatePriceDisplay();
      }
    });
  });
}

    if (regularPriceElement) {
      const observer = new MutationObserver(() => {
        syncPrice();
        updatePriceDisplay();
        handleSubscriptionChange();
      });
      observer.observe(regularPriceElement, {
        childList: true,
        characterData: true,
        attributes: true,
        subtree: true
      });
    }
  }

  initPriceSync();

  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId.includes('template--')) {
      setTimeout(() => {
        initPriceSync();
      }, 50);
    }
  });

  waitForElement('variant-radios', (variantRadios) => {
    const labels = variantRadios.querySelectorAll('label');
    if (!labels.length) {
      console.warn('No variant radio labels found.');
      return;
    }

    labels.forEach(label => {
      updateLabelMetaFields(label);
    });

    variantRadios.addEventListener('change', () => {
      console.log('Variant changed, updating labels.');
      labels.forEach(label => {
        updateLabelMetaFields(label);
      });
    });
  });

  waitForElement('.rc_widget', (rcWidget) => {
    console.log('Recharge widget detected.');
    const form = document.querySelector('form[action*="/cart/add"], .product-form, .installment');
    if (!form) {
      console.warn('Product form not found.');
      return;
    }

    const addToCartButton = form.querySelector('[type="submit"], button[name="add"], .rc_widget__button, .rc_add_to_cart, .rc_button, .rc_widget button, .shopify-payment-button__button');
    if (addToCartButton) {
      ensureElementVisibility(addToCartButton, 'button');
    }

    const inputs = rcWidget.querySelectorAll('input[type="radio"], input[type="checkbox"]');
    const options = rcWidget.querySelectorAll('.rc_widget__option');
    console.log('Recharge widget inputs:', Array.from(inputs).map(input => ({
      id: input.id,
      name: input.name,
      value: input.value,
      class: input.className,
      checked: input.checked
    })));
    console.log('Recharge widget options:', Array.from(options).map(opt => ({
      class: opt.className,
      text: opt.textContent.trim()
    })));

    const subSaveOption = rcWidget.querySelector('.rc_widget__option--subsave, .subscription-radio');
    const oneTimeOption = Array.from(options).find(opt => !opt.classList.contains('rc_widget__option--subsave') && !opt.classList.contains('subscription-radio'));

    if (subSaveOption && oneTimeOption && subSaveOption.parentNode === oneTimeOption.parentNode) {
      const parent = subSaveOption.parentNode;
      if (oneTimeOption.compareDocumentPosition(subSaveOption) & Node.DOCUMENT_POSITION_FOLLOWING) {
        parent.insertBefore(subSaveOption, oneTimeOption);
        console.log('Recharge options reordered: Subscribe & Save first.');
      }
    } else {
      console.warn('Could not reorder Recharge options: Elements not found or not siblings.');
    }

    const subSaveInput = rcWidget.querySelector('.rc_widget__option--subsave input[type="radio"], .rc_widget__option--subsave input[type="checkbox"], .subscription-radio input[type="radio"], .subscription-radio input[type="checkbox"]');
    if (subSaveInput) {
      subSaveInput.checked = true;
      subSaveInput.click();
      subSaveInput.dispatchEvent(new Event('change', { bubbles: true }));
      console.log('Set Subscribe & Save as default with click and change event.');
      setTimeout(() => {
        const labels = document.querySelectorAll('variant-radios label');
        labels.forEach(label => {
          updateLabelMetaFields(label);
        });
        if (isSubscriptionActive()) {
          handleSubscriptionChange();
          console.log('Delayed subscription update triggered.');
        }
      }, 1500);
    } else {
      handleSubscriptionChange();
      console.warn('Subscribe & Save input not found for default selection.');
    }

    const isSubSaveActive = isSubscriptionActive();
    toggleSubscriptionBenefits(isSubSaveActive);

    const rechargeObserver = new MutationObserver(() => {
      const isActive = isSubscriptionActive();
      toggleSubscriptionBenefits(isActive);
      const labels = document.querySelectorAll('variant-radios label');
      labels.forEach(label => {
        updateLabelMetaFields(label);
      });
      updatePriceDisplay();
    });

    rechargeObserver.observe(rcWidget, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true
    });

    rcWidget.querySelectorAll('.rc_option, .rc-radio').forEach(opt => {
      opt.addEventListener('click', () => {
        handleSubscriptionChange();
      });
    });
  });

  waitForElement('form[action*="/cart/add"], .product-form, .installment', (form) => {
    const addToCartButton = form.querySelector('[type="submit"], button[name="add"], .rc_widget__button, .rc_add_to_cart, .rc_button, .rc_widget button, .shopify-payment-button__button');
    if (addToCartButton) {
      ensureElementVisibility(addToCartButton, 'button');
    }
  });

  window.handleSubscriptionChange = function() {
    console.log('External subscription change triggered.');
    const labels = document.querySelectorAll('variant-radios label');
    labels.forEach(label => {
      updateLabelMetaFields(label);
    });
    initPriceSync();
  };
});




